import { T } from "@tolgee/react";
import classNames from "classnames";
import { ButtonHTMLAttributes, FC } from "react";
import { ChevronRight } from "react-feather";

export const PreviewButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className,
  ...props
}) => {
  return (
    <button
      {...props}
      className={classNames(
        "bg-indigo-500 md:py-2.5 md:px-4 py-2 px-[14px] rounded-lg",
        className
      )}
    >
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold leading-5 text-white">
          <T keyName="button-preview" />
        </span>
        <ChevronRight size={20} color="white" />
      </div>
    </button>
  );
};
